import { Platform } from "react-native";
import RNPostHog from "./RNPostHog";
import WebPostHog from "./WebPostHog";

let BEPostHog = Platform.select({
  ios: RNPostHog,
  android: RNPostHog,
  web: WebPostHog as any
})

export default BEPostHog